import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import { PostPayload } from '..';
import { AllAPIResponses, CarbonError, ReactionType } from './../../../index';

type Params = {
  id: number;
};

const put = async (
  params: Params,
  payload: Partial<PostPayload>,
  headers?: Headers
): Promise<AllAPIResponses<ReactionType>> => {
  try {
    const resp = await req.put(
      `/api/reactions/${params.id}`,
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as ReactionType,
          response: clone,
        };
      case 304:
        return { error: new Error('Not Modified'), response: clone };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default put;
